// extracted by mini-css-extract-plugin
module.exports = {"preloaderWrapper":"PreLoader_preloaderWrapper__3VfoX"};